<div class="row">
    <div class="col-md-2">
        <a [routerLink]="['/']"><h4>NPP</h4></a>
    </div>
    <div class="col-md-10">
        <ul class="main-header-nav">
            <li>
                <button class="btn btn-sm btn-primary button-with-icon" [routerLink]="['/notifications']">
                    {{ 'notifications' | translate }}
                    <svg class="icon" width="14" height="14">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="./sprites/symbol/icons.svg#bell"
                             fill="currentColor"/>
                    </svg>
                </button>
            </li>
            <li>
                <app-import-customers-modal></app-import-customers-modal>
            </li>
        </ul>
    </div>
</div>




// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/header/header.component.html